
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import Pagination from '@mui/material/Pagination';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_create: false,
            modal_delete: false,
            modal_update: false,

            loading: false,
            data: null,

            filter_name: "",
            company_id: "",
            company_name: "",
            tax_number: "",
            address: "",
            business_location: "",
            email: "",
            phone: "",

            page: 1,
            data_search: "",
            company_id: ""

        }
    }
    async componentDidMount() {
        await this.Get();
    }
    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: this.state.page,
            data_search: this.state.data_search,
            company_type: 2,
            company_id: this.state.company_id
        }
        let result = await GET(tokens, "v1/TH/company-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data: result });
        }
        this.setState({ loading: false });
    }

    Create = async () => {
        if (validate(this.state, ["category_name"])) { return };
        this.setState({ loading: true });
        let body = {
            company_type: 2,
            company_name: this.state.company_name,
            tax_number: this.state.tax_number,
            address: this.state.address,
            business_location: "",
            email: this.state.email,
            phone: this.state.phone,
        }
        let result = await POST(tokens, "v1/TH/company-info/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/master/list-suppliers");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        if (validate(this.state, ["category_name"])) { return };
        this.setState({ loading: true });
        let body = {
            company_type: 2,
            company_id: this.state.company_id,
            company_name: this.state.company_name,
            tax_number: this.state.tax_number,
            address: this.state.address,
            business_location: "",
            email: this.state.email,
            phone: this.state.phone,
        }
        let result = await PUT(tokens, "v1/TH/company-info/update", body);
        if (result && result.status) {
            success_url("/master/list-suppliers");
        }
        this.setState({ loading: false });
    }
    Delete = async () => {
        this.setState({ loading: true });
        let result = await DELETE(tokens, "v1/TH/company-info/delete/" + this.state.company_id, null);
        if (result && result.status) {
            success_url("/master/list-suppliers");
        }
        this.setState({ loading: false });
    }

    clear_form = () => {
        this.setState({
            modal_create: false,
            modal_delete: false,
            modal_update: false,

            loading: false,

            company_id: "",
            name: "",
            address: "",
            business_location: "",
        })
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" page3="จัดการบริษัทที่จำหน่าย" />
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>จัดการบริษัทที่จำหน่าย</b></h3>
                            <div className="d-flex">
                                <button className="btn btn-outline-orange mx-1" onClick={() => { window.location.href = "/master" }}>
                                    <span className="icon me-2">{"\uf060"}</span>ย้อนกลับ
                                </button>
                                <button className="btn btn-orange mx-1" onClick={() => {
                                    this.clear_form();
                                    setTimeout(() => {

                                        this.setState({ modal_create: true })

                                    }, 10);
                                }}>
                                    เพิ่มบริษัทที่จำหน่าย
                                </button>
                            </div>
                        </div>
                        <div className="w-100 card border-0 p-0">
                            <div className="d-flex mx-0 px-3 pt-3">
                                <input
                                    className="form-control wpx-250 bg-contain border-0 mx-1 mb-2"
                                    type="text"
                                    placeholder="ค้นหา..."
                                    onChange={(e) => { this.setState({ data_search: e.target.value }) }}
                                    onKeyUp={(e) => {
                                        if (e.key === "Enter") {
                                            this.setState({ page: 1 });
                                            setTimeout(() => {
                                                this.Get();
                                            }, 10);
                                        }
                                    }}
                                    value={this.state.data_search}
                                />

                                <button className="btn btn-orange mx-1" onClick={() => {
                                    this.setState({ page: 1 });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    ค้นหา
                                </button>
                                <button className="btn btn-outline-orange mx-1" onClick={() => {
                                    this.setState({ page: 1, data_search: "" });
                                    setTimeout(() => {
                                        this.Get();
                                    }, 10);
                                }}>
                                    รีเซ็ต
                                </button>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-borderless table-striped">
                                    <thead className="bg-primary">
                                        <tr>
                                            <th className="text-left text-white">ชื่อบริษัทที่จำหน่าย</th>
                                            <th className="text-left text-white">ที่อยู่บริษัทที่จำหน่าย</th>
                                            <th className="text-left text-white">อีเมล</th>
                                            <th className="text-center text-white">เบอร์โทรศัพท์</th>
                                            <th className="text-center text-white">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data && this.state.data.data.map((item, index) => (
                                            <tr key={index}>
                                                <td className="text-left">{item.company_name ? item.company_name : "-"}</td>
                                                <td className="text-left">{item.address ? item.address : "-"}</td>
                                                <td className="text-left">{item.email ? item.email : "-"}</td>
                                                <td className="text-center">{item.phone ? item.phone : "-"}</td>
                                                <td className="text-center">
                                                    <div className="w-100 d-flex justify-content-center">
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-primary-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => {
                                                                this.setState({
                                                                    modal_update: true,
                                                                    company_id: item.company_id,
                                                                    company_name: item.company_name,
                                                                    tax_number: item.tax_number,
                                                                    address: item.address,
                                                                    phone: item.phone,
                                                                    email: item.email,
                                                                })
                                                            }}>
                                                            <label className="pointer icon text-primary p-2">{"\uf044"}</label>
                                                        </div>
                                                        <div className="pointer wpx-30 hpx-30 rounded bg-danger-light mx-1 d-flex justify-content-center align-items-center"
                                                            onClick={() => {
                                                                this.setState({
                                                                    modal_delete: true,
                                                                    company_id: item.company_id,
                                                                    company_name: item.company_name,
                                                                    tax_number: item.tax_number,
                                                                    address: item.address,
                                                                    phone: item.phone,
                                                                    email: item.email,
                                                                })
                                                            }}>
                                                            <label className="pointer icon text-danger p-2">{"\uf2ed"}</label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* pagination */}
                                {this.state.data && (
                                    <div className="d-flex flex-wrap justify-content-between w-100 px-3 mt-3">
                                        <label>
                                            แสดง {this.state.data.end_index} รายการ จาก {this.state.data.count} รายการ
                                        </label>
                                        <Pagination
                                            count={this.state.data.page_number}
                                            page={this.state.data.page}
                                            color="primary"
                                            showFirstButton
                                            shape="rounded"
                                            showLastButton
                                            onChange={(event, value) => {
                                                this.setState({ page: value })
                                                setTimeout(() => { this.Get() }, 5)
                                            }} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* create update */}
                <Modal show={this.state.modal_create || this.state.modal_update}
                    onHide={() => { this.setState({ modal_create: false, modal_update: false }) }}>
                    <Modal.Header><Modal.Title><b>{this.state.modal_create ? "เพิ่มบริษัทที่จำหน่าย" : "แก้ไขบริษัทที่จำหน่าย"}</b></Modal.Title></Modal.Header>
                    <Modal.Body>
                        {/* ชื่อบริษัท */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">ชื่อบริษัท:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => { this.setState({ company_name: e.target.value }) }}
                                value={this.state.company_name}
                            />
                        </div>
                        {/* เลขท่ีผู้เสียภาษี */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">เลขท่ีผู้เสียภาษี:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => {
                                    if (!float(e.target.value)) {
                                        return
                                    }
                                    this.setState({ tax_number: e.target.value })
                                }}
                                value={this.state.tax_number}
                            />
                        </div>
                        {/* ที่อยู่ */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">ที่อยู่:</label>
                            <textarea
                                className="form-control"
                                placeholder=""
                                onChange={(e) => {
                                    this.setState({ address: e.target.value })
                                }}
                                value={this.state.address}
                            />
                        </div>
                        {/* เบอร์โทรศัพท์ */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">เบอร์โทรศัพท์:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                maxLength={10}
                                onChange={(e) => {
                                    if (!float(e.target.value)) {
                                        return
                                    }
                                    this.setState({ phone: e.target.value })
                                }}
                                value={this.state.phone}
                            />
                        </div>
                        {/* อีเมล */}
                        <div className="w-100 mb-2">
                            <label className="mb-2">อีเมล:</label>
                            <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                onChange={(e) => {
                                    this.setState({ email: e.target.value })
                                }}
                                value={this.state.email}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-orange w-100" onClick={() => { this.setState({ modal_create: false, modal_update: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-orange w-100"
                                    onClick={() => {
                                        if (this.state.modal_create) {
                                            this.Create();
                                        } else {
                                            this.Update();
                                        }
                                    }}>
                                    {this.state.modal_create ? "เพิ่ม" : "บันทึก"}
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {/* ลบข้อมูล */}
                <Modal show={this.state.modal_delete} onHide={() => { this.setState({ modal_delete: false }) }}>
                    <Modal.Header> <Modal.Title> <b>ต้องการลบสินค้า</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <label>
                            ท่านต้องการลบสินค้า “{this.state.company_name}”
                        </label>
                    </Modal.Body>
                    <Modal.Footer>
                        <label className="mb-2 w-100">
                            หมายเหตุ ไม่สามารถกู้คืนได้
                        </label>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.Delete() }}>
                                    ลบ
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_delete: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div >
        )
    }
}
